import { TaskRejectReasonResponse } from '@bringg/types';
import TaskRejectReasonStore from '../task-reject-reasons-store';

function map(taskRejectReason: TaskRejectReasonResponse) {
	return { current: new TaskRejectReasonStore(taskRejectReason) };
}

export const taskRejectReasonsStoreMapper = { map };
